import { FREE_TIER } from '../plan/free-tier';
import { useCurrentOrgContext } from './use-current-org';

export interface Plan {
  /** A free individual account (ADR-014), rather than a team. */
  isPersonal: boolean;
  /** How many devices this organization may enrol, or null when there is no cap. */
  deviceLimit: number | null;
  /** How many days of events are kept, or null when retention is not capped. */
  retentionDays: number | null;
  /** True while the organization is being moved to its own database (story #136). */
  isUpgrading: boolean;
}

/**
 * The current organization's plan, for deciding what to render.
 *
 * Defaults to a TEAM when nothing is known yet. That direction is deliberate: guessing "personal"
 * would briefly show a paying customer the cut-down dashboard on every cold load, which looks like
 * their data has gone. Guessing "team" briefly offers a free user a control the server then refuses -
 * which is why the server refuses it at all (story #134).
 */
export function usePlan(): Plan {
  const { currentOrg, orgStatus } = useCurrentOrgContext();
  const isPersonal = currentOrg?.isPersonal === true;

  return {
    isPersonal,
    deviceLimit: isPersonal ? FREE_TIER.deviceLimit : null,
    retentionDays: isPersonal ? FREE_TIER.retentionDays : null,
    isUpgrading: orgStatus === 'Upgrading',
  };
}
